import { ImportedListing } from '../../_types/imported-listing'
import { formatRelativeTime } from '../../_utilities/relative-time'

const formatBedrooms = (bedrooms: number | null): string | null => {
  if (bedrooms === null) {
    return null
  }

  if (bedrooms === 0) {
    return 'Studio'
  }

  return `${bedrooms} bed${bedrooms === 1 ? '' : 's'}`
}

const formatBathrooms = (bathrooms: number | null): string | null => {
  if (bathrooms === null) {
    return null
  }

  return `${bathrooms} bath${bathrooms === 1 ? '' : 's'}`
}

const formatPrice = (
  priceMonthly: number | null,
  priceCurrency: string,
): string => {
  if (priceMonthly === null) {
    return 'Price not found'
  }

  const symbol = priceCurrency === 'USD' ? 'US$' : '$'
  return `${symbol}${priceMonthly.toLocaleString('en-CA')}/mo`
}

const formatLastChecked = (lastScrapedAt: number): string => {
  return formatRelativeTime(lastScrapedAt, {
    capitalised: false,
    yesterdayLabel: false,
    emptyTimestampLabel: 'never checked',
  })
}

const buildMetaParts = (listing: ImportedListing): string[] => {
  const parts: string[] = []

  const beds = formatBedrooms(listing.bedrooms)
  const baths = formatBathrooms(listing.bathrooms)

  if (beds !== null) {
    parts.push(beds)
  }
  if (baths !== null) {
    parts.push(baths)
  }
  if (listing.city !== '') {
    parts.push(listing.city)
  }
  if (listing.propertyType !== null) {
    const capitalised =
      listing.propertyType.charAt(0).toUpperCase() +
      listing.propertyType.slice(1)
    parts.push(capitalised)
  }

  return parts
}

const formatSourceSiteLabel = (
  sourceSite: ImportedListing['sourceSite'],
): string => {
  if (sourceSite === 'unknown') {
    return 'Web'
  }

  return sourceSite
}

export {
  formatBedrooms,
  formatBathrooms,
  formatPrice,
  formatLastChecked,
  buildMetaParts,
  formatSourceSiteLabel,
}
